import { useEffect, useState } from 'react';
import ABI from './abi.json';
import Web3 from 'web3';
import toast from 'react-hot-toast';

export const useContract = () => {
    const [contract, setContract] = useState(null);

    useEffect(() => {
        try {
            const web3 = new Web3("https://bsc.drpc.org/");

            const newContract = new web3.eth.Contract(ABI, "0x667C69bD295f0dc38b5b97DB06556129418514c6");

            setContract(newContract);
        } catch (error) {
            console.error('Error initializing contract:', error);
        }
    }, []);

    return contract;
};